module.exports = __webpack_public_path__ + "img/d3.7629d6d6.png";